import {useServices} from "../../../react-hooks/use-services.hook";
import React, {useState} from "react";
import {IStandardToastDefinition} from "../../../services/toaster/toaster.service.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {TextareaBox} from "../../../basic-ui-components/form/textarea.box";
import {Label} from "../boxes/label";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";

const BASE_CONTENT = {
    title: 'Test toaster',
    message: 'This is an example for standard toaster',
    showProgressBar: true,
    showDefaultImage: true,
    showDefaultButton: false,
};
const BASE_BUTTON = {
    text: 'Close toaster',
    onClick: (closeToast) => {closeToast()}
};

export const ToasterShowcase: React.FC = () => {
    const [toasterOpt, setToasterOpt] = useState(BASE_CONTENT);
    const services = useServices();

    const onChangeInput = (ev) => {
        const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
        const field = ev.target.name;
        setToasterOpt({...toasterOpt, [field]: value});
    };

    const showToaster = () => {
        const customizeToasterOptions: IStandardToastDefinition = {
            contentProps: {
                title: toasterOpt.title,
                message: toasterOpt.message,
                image: toasterOpt.showDefaultImage && 'DEFAULT_TOAST_IMAGE',
                button: toasterOpt.showDefaultButton && BASE_BUTTON
            },
            toastOptions: {
                timeout: toasterOpt.showProgressBar && TimeSpan.fromMilliseconds(5000)
            }
        };

        services.toaster.showStandardToast(customizeToasterOptions);
    };

    const closeToasters = () => {
        services.toaster.removeAllToasts()
    };

    return (<>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <h3>Title:</h3>
                    <input type="text" value={toasterOpt.title} name="title" onChange={onChangeInput} />
                </ShowcaseConfigurationBox>

                <ShowcaseConfigurationBox>
                    <h3>Message:</h3>
                    <TextareaBox
                        style={{fontSize: "1.6rem", width: "100%", resize: "vertical"}}
                        rows={4}
                        name='message'
                        value={toasterOpt.message}
                        onChange={onChangeInput}
                    />
                </ShowcaseConfigurationBox>

                <ShowcaseConfigurationBox>
                    <h3>Options:</h3>
                    <div>
                        <input
                            type="checkbox"
                            name="showProgressBar"
                            id="showProgressBar"
                            checked={toasterOpt.showProgressBar}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showProgressBar'>Show Progress bar (5s)</Label>
                    </div>

                    <div>
                        <input
                            type="checkbox"
                            name="showDefaultImage"
                            id="showDefaultImage"
                            checked={toasterOpt.showDefaultImage}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showDefaultImage'>Show default image</Label>
                    </div>

                    <div>
                        <input
                            type="checkbox"
                            name="showDefaultButton"
                            id="showDefaultButton"
                            checked={toasterOpt.showDefaultButton}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showDefaultButton'>Show default button</Label>
                    </div>
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>

            <ShowcaseContentContainerBox>
                <Button preset="primary" onClick={showToaster}>Show toaster</Button>
                <Button preset="info" onClick={closeToasters}>Close toasters</Button>
            </ShowcaseContentContainerBox>
        </>
    );
}